import { useState, useEffect } from 'react'
import Block from '../../../components/Block/Block'
import EventCalendar from '../../../components/EventCalendar/EventCalendar'
import FadeIn from '../../../components/FadeIn/FadeIn'
import style from './calendarblock.module.scss'
import { fetchEvents } from '../../../services/api'

const CalendarBlock = () => {
    const [events, setEvents] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        const loadEvents = async () => {
            try {
                setLoading(true)
                const { data } = await fetchEvents({
                    populate: '*',
                    sort: 'StartDate:asc',
                    pageSize: 100 // Получаем все события
                })

                console.log('Events API response:', data) // Для отладки

                // Форматируем события для календаря
                const formattedEvents = data.map(event => {
                    // Безопасное получение данных с проверкой на существование
                    const eventData = event.attributes || {}
                    
                    return {
                        id: event.id,
                        title: eventData.Title || 'Событие',
                        start: new Date(eventData.StartDate),
                        end: new Date(eventData.EndDate),
                        type: eventData.Type || 'other',
                        description: eventData.Description || '',
                        facility: eventData.facility?.data?.attributes?.Title || null,
                        sport: eventData.sport?.data?.attributes?.Title || null,
                        coach: eventData.coach?.data?.attributes 
                            ? `${eventData.coach.data.attributes.LastName || ''} ${eventData.coach.data.attributes.FirstName || ''}`.trim()
                            : null,
                        location: eventData.Location || '',
                        image: eventData.Image?.data?.attributes?.url || null,
                        isEvent: true // Помечаем как событие из API
                    }
                })

                console.log('Formatted events:', formattedEvents) // Для отладки
                setEvents(formattedEvents)
            } catch (err) {
                console.error('Error loading events:', err)
                console.error('Error details:', err.response?.data) // Детали ошибки
                setError('Не удалось загрузить события. Пожалуйста, попробуйте позже.')
            } finally {
                setLoading(false)
            }
        }

        loadEvents()
    }, [])

    // Функция для перевода типов событий на русский
    const getEventTypeLabel = (type) => {
        const typeLabels = {
            'competition': 'Соревнование',
            'training': 'Тренировка', 
            'meeting': 'Собрание',
            'holiday': 'Праздник',
            'seminar': 'Семинар',
            'other': 'Другое'
        }
        return typeLabels[type] || 'Событие'
    }

    // Дополнительная обработка событий для календаря
    const processedEvents = events.map(event => ({
        ...event,
        typeLabel: getEventTypeLabel(event.type),
        // Добавляем CSS классы для разных типов событий
        className: `event-type-${event.type}`,
        // Форматируем описание для отображения
        extendedProps: {
            description: event.description,
            facility: event.facility,
            sport: event.sport,
            coach: event.coach,
            location: event.location,
            image: event.image,
            type: event.type,
            typeLabel: getEventTypeLabel(event.type)
        }
    }))

    return (
        <Block
            flexDirection='column'
            justifyContent='center'
            alignItems='start'
            width="75%"
            height='fit-content'
            background="rgba(255, 255, 255, 0.85)"
            header='КАЛЕНДАРЬ СОБЫТИЙ'
        >
            <FadeIn>
                <div className={style.content}>
                    {error ? (
                        <div className={style.error}>
                            <p>{error}</p>
                            <button 
                                onClick={() => window.location.reload()}
                                className={style.retryButton}
                            >
                                Попробовать снова
                            </button>
                        </div>
                    ) : (
                        <EventCalendar 
                            apiEvents={processedEvents}
                            loading={loading}
                            error={error}
                        />
                    )}
                </div>
            </FadeIn>
        </Block>
    )
}

export default CalendarBlock